import User from "./data/user/index"; //用户模块翻译文件引入
import home from "./data/home/index";
import order from "./data/order/index";
import money from "./data/money/index";

const zh = {
  language: {
    name: "English",
  },
  user: {
    login: User.Login.ZH,
    register: User.Register.ZH,
  },
  home: {
    homePage: home.homePage.ZH,
    baoguo: home.baoguo.ZH,
    yunfei: home.yunfei.ZH,
    my: home.my.ZH,
  },
  order: {
    orders: order.orders.ZH,
    packages: order.packages.ZH,
    other: order.other.ZH,
  },
  money: {
    amount: money.amount.ZH,
    JY: money.JY.ZH,
  },
};
export default zh;
